import { keys } from 'ts-transformer-keys';
import { FreeWallPreviewCompileRequest } from './FreeWallPreviewCompileRequest';

export const freeWallPreviewCompileRequestKeys =
  keys<FreeWallPreviewCompileRequest>();
